/**
 * @module Template-List-Pagination
 */

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

/**
 * 
 * @param props - Pagination properties
 * @returns Common pagination style used with different list across template
 */
const SectionPagination = ({ currentPage, totalPages, onPageChange }: PaginationProps) => {
    const handlePageClick = (page: number, e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onPageChange(page);
    };

    const handlePrevClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNextClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let end = Math.min(totalPages, start + maxVisiblePages - 1);
        
        // Adjust start if we're near the end
        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1);
        }
        
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        
        return pages;
    };

    const pageNumbers = getPageNumbers();

    return (
        <div className="pagination-outer d-flex justify-content-center">
            <div className="pagination-style1">
                <ul className="clearfix">
                    <li className={`prev ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a 
                            href="#" 
                            onClick={handlePrevClick}
                            className={currentPage === 1 ? 'disabled' : ''}
                            style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                        >
                            <span> <i className="fa-solid fa-arrow-left-long" /> </span>
                        </a>
                    </li>
                    {pageNumbers.map((page) => (
                        <li key={page} className={currentPage === page ? 'active' : ''}>
                            <a 
                                href="#" 
                                onClick={(e) => handlePageClick(page, e)}
                                style={{ cursor: 'pointer' }}
                            >
                                {page.toString().padStart(2, '0')}
                            </a>
                        </li>
                    ))}
                    <li className={`next ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <a 
                            href="#" 
                            onClick={handleNextClick}
                            className={currentPage === totalPages ? 'disabled' : ''}
                            style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                        >
                            <span> <i className="fa-solid fa-arrow-right-long" /> </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default SectionPagination;